import type { ReactNode } from "react";
import "./DashboardLoadingOverlay.scss";
import FilterIcon from "../../_assets/icons/FilterIcon";

type DashboardLoadingOverlayProps = {
  open: boolean;
  children?: ReactNode;
};

const DashboardLoadingOverlay: React.FC<DashboardLoadingOverlayProps> = ({
  open,
  children,
}) => {
  if (!open) return null;

  return (
    <div className="dashboard-loading-overlay font-bms">
      {/* Dashboard Skeleton Loaders */}
      <div className="dashboard-loading-skeleton">
        {/* Header */}
        <div className="skeleton-header">
          <span className="skeleton-text">← Back to Oasis Home</span>
        </div>

        {/* Title and Button */}
        <div className="skeleton-title-section">
          <span className="skeleton-text-title">Content QA Dashboard</span>
          <span className="skeleton-text-button">Start new analysis</span>
        </div>

        {/* Key Metrics Section Header */}
        <div className="skeleton-section-header">
          <span className="skeleton-text-section-title">Key metrics</span>
          <div className="skeleton-actions">
            <FilterIcon />
            <span className="skeleton-text-action">
              Download report in Excel
            </span>
          </div>
        </div>

        {/* Metric Cards */}
        <div className="skeleton-metrics-grid font-semibold">
          <div className="skeleton-metric-card">
            <span className="skeleton-text-label">Total Files Analyzed</span>
            <div className="skeleton-value"></div>
          </div>
          <div className="skeleton-metric-card">
            <span className="skeleton-text-label">
              Average Compliance Score
            </span>
            <div className="skeleton-value"></div>
          </div>
          <div className="skeleton-metric-card">
            <span className="skeleton-text-label">Compliant Files</span>
            <div className="skeleton-value"></div>
          </div>
          <div className="skeleton-metric-card">
            <span className="skeleton-text-label">Total Issues found</span>
            <div className="skeleton-value"></div>
          </div>
        </div>

        {/* QA Assets Section */}
        <div className="skeleton-qa-assets-header">
          <span className="skeleton-text-section-title">My QA assets</span>
        </div>

        {/* Tabs */}
        <div className="skeleton-tabs">
          <span className="skeleton-text-tab">QA Findings</span>
          <span className="skeleton-text-tab">Tasks</span>
          <span className="skeleton-text-tab">Analytics</span>
          <span className="skeleton-text-tab">Usage Data</span>
        </div>

        {/* Table Section */}
        <div className="skeleton-findings-section">
          <div className="skeleton-loading-text">Loading QA Findings...</div>
        </div>
      </div>

      {/* Modal/Content Overlay */}
      <div className="dashboard-loading-modal-container">{children}</div>
    </div>
  );
};

export default DashboardLoadingOverlay;
